import axios, { AxiosInstance } from "axios";
import { setupInterceptors } from "./interceptors";
import { getEnv } from "@/core/env";

// Crear la instancia base de Axios
const api: AxiosInstance = axios.create({
  // URL base tomada de las variables de entorno
  baseURL: getEnv("VUE_APP_API_URL", "http://localhost:8082/api/v1"),
  // Timeout por defecto (ej. 10 segundos)
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Configurar los interceptores a la instancia
setupInterceptors(api);

export default api;
